module.exports = __webpack_public_path__ + "img/folder_icon.8cfb24b7.svg";